import {Grid, Paper} from "@mui/material"
import {DataGrid} from "@mui/x-data-grid"
import dayjs from "dayjs"
import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import PriceService from "src/services/price-service"
import {DATE_FORMAT_SHOW} from "src/utils/constants"
import {localeBRDataGridText} from "src/utils/data-grid-local-text"
import {formatStringToFloatDecimalCase} from "src/utils/format-decimal"


const PriceTableVariationPage = ({date, setLoading, setExportFileCsv}) => {
    const priceService = new PriceService()
    const [priceList, setPriceList] = useState([])

    useEffect(() => {
        setExportFileCsv(() => () => priceService.exportDataVariationToCsv(date))
        loadPrices(date)
    }, [])

    const loadPrices = () => {
        setLoading(true)
        priceService.loadTablePriceVariantion(date, date)
            .then((response) => {
                setLoading(false)
                const {body} = response
                const {data} = body
                const rows = data.map((obj, index) => ({...obj, id: index}))
                setPriceList(rows)
            }).catch(() => {
            setLoading(false)
        })
    }

    const renderCellWithTooltip = (params) => <div title={params.value}>{params.value}</div>

    const formatValue = (value, minimum = 2, maximum = 6) =>
        formatStringToFloatDecimalCase(value, minimum, maximum)

    const columns = [
        {   field: "CETIP",
            headerName: "CETIP",
            flex: 1,
            minWidth: 200,
            renderCell: renderCellWithTooltip},
        {
            field: "DataReferencia",
            headerName: "Data Referência",
            minWidth: 150,
            type: "date",
            valueFormatter: (params) => (params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ""),
        },
        {
            field: "VNAPUPAR",
            headerName: "VNA",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "AtualizacaoMonetariaIncrementoPUPAR",
            headerName: "Atualização Monetária Incremento",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "JurosAcruadosPUPAR",
            headerName: "Juros Acruados",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "TaxaRiskFreeAnterior",
            headerName: "Taxa RiskFree Anterior",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "TaxaRiskFreeAtual",
            headerName: "Taxa RiskFree Atual",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "DeltaRiskFree",
            headerName: "Delta RiskFree",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "SpreadCreditoAnterior",
            headerName: "Spread Crédito Anterior",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "SpreadCreditoAtual",
            headerName: "Spread Crédito Atual",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "DeltaSpreadCredito",
            headerName: "Delta Spread Crédito",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "AjusteMTMDiario",
            headerName: "Ajuste MTM Diário",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "AmortizacaoOrdinariaPUPAR",
            headerName: "Amortização Ordinária",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "AmortizacaoExtraordinariaPUPAR",
            headerName: "Amortização Extraordinária",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "JurosPUPAR",
            headerName: "Cupom Juros",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "IncorporacaoJurosPUPAR",
            headerName: "Incorporação de Juros",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "PremioPUPAR",
            headerName: "Prêmio",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "PagamentoPUPAR",
            headerName: "Pagamento",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "DataEventoProximo",
            headerName: "Data Próximo Evento",
            minWidth: 150,
            type: "date",
            valueFormatter: (params) => (params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ""),
        },
        {
            field: "ClassificacaoProximoEvento",
            headerName: "Próximo Evento",
            flex: 1,
            minWidth: 200,
            renderCell: renderCellWithTooltip
        },
        {
            field: "ValorProximoEvento",
            headerName: "Valor do Próximo Evento",
            flex: 1,
            minWidth: 200,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "PUPARAnterior",
            headerName: "PUPAR Anterior",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "PUPARAtual",
            headerName: "PUPAR Atual",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "DeltaPUPAR",
            headerName: "Delta PUPAR",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "VarPUPAR",
            headerName: "%Var PUPAR",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "PU_MTMAnterior",
            headerName: "PU MTM Anterior",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "PU_MTMAtual",
            headerName: "PU MTM Atual",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "DeltaPU_MTM",
            headerName: "Delta PU MTM",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "VarPUMTM",
            headerName: "%Var PU MTM",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => formatValue(params.value)
        },
        {
            field: "JustificativaPUPAR",
            headerName: "Justificativa PUPAR",
            flex: 1,
            minWidth: 200,
            renderCell: renderCellWithTooltip
        },
        {
            field: "JustificativaPUMTM",
            headerName: "Justificativa PU MTM",
            flex: 1,
            minWidth: 200,
            renderCell: renderCellWithTooltip
        },
    ]

    return (
        <>
            <br/>
            <Grid container direction="row" justifyContent="center" spacing={2}>
                <Grid item xl={12} md={12} xs={12}>
                    <Paper sx={{ height: 'calc(120vh - 290px)', width: '100%' , overflow: 'hidden'}}>
                        <DataGrid
                            rows={priceList}
                            columns={columns}
                            pageSize={25}
                            disableRowSelectionOnClick
                            sortingOrder={["asc", "desc"]}
                            localeText={localeBRDataGridText}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    )
}

// Adicionando prop-types para validação
PriceTableVariationPage.propTypes = {
    date: PropTypes.string,
    setLoading: PropTypes.func,
    loading: PropTypes.bool,
    setExportFileCsv: PropTypes.func,
}
export default PriceTableVariationPage
